import { render, staticRenderFns } from "./IconPlay.vue?vue&type=template&id=2c63b594&"
import script from "./IconPlay.vue?vue&type=script&lang=js&"
export * from "./IconPlay.vue?vue&type=script&lang=js&"
import style0 from "./IconPlay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports